import { ResponsePassiveDocumentCreation } from '../../shared/interfaces';
import { createReducer, on } from '@ngrx/store';
import { PassiveDocumentCreationActions } from '../actions';
import { PassiveDocumentCreationTypes } from '../../shared/enums';

export interface PassiveDocumentCreationState {
    response: ResponsePassiveDocumentCreation;
    request;
    error: any;
}

export const PassiveDocumentCreationInitialState: PassiveDocumentCreationState = {
    response: null,
    request: null,
    error: null
};

const _passiveDocumentCreationReducer = createReducer(
    PassiveDocumentCreationInitialState,

    on(PassiveDocumentCreationActions.getPassiveDocumentCreation, (state, { request }) => ({
        ...state,
        request,
        error: null
    })),

    on(PassiveDocumentCreationActions.getPassiveDocumentCreationSucess, (state, { response }) => ({
        ...state,
        response,
        error: null
    })),

    on(PassiveDocumentCreationActions.getPassiveDocumentCreationError, (state, { payload }) => ({
        ...state,
        request: null,
        response: null,
        error: {
            statusCode: payload.statusCode,
            message: payload.message
        }
    })),

    on(PassiveDocumentCreationActions.cleanState, (state) => ({
        ...state,
        request: null,
        response: null,
        error: null
    }))
);

export function passiveDocumentCreationReducer(state, action) {
    if (action.type === PassiveDocumentCreationTypes.PASSIVE_DOCUMENT_CREATION) {
        state = undefined;
    }
    return _passiveDocumentCreationReducer(state, action);
}
